'use client';

import React from 'react';
import Header from '@/components/common/Header';
import Footer from '@/app/homepage/components/Footer';
import { useTranslation } from '@/hooks/useTranslation';
import Icon from '@/components/ui/AppIcon';

export default function VerificationProcessPage() {
    const { t } = useTranslation();

    const steps = [
        {
            step: '01',
            title: t('businessRegistration'),
            description: t('businessRegistrationDesc'),
            icon: 'DocumentTextIcon',
        },
        {
            step: '02',
            title: t('certificationValidation'),
            description: t('certificationValidationDesc'),
            icon: 'ShieldCheckIcon',
        },
        {
            step: '03',
            title: t('facilityInspectionTitle'),
            description: t('facilityInspectionDesc2'),
            icon: 'BuildingOffice2Icon',
        },
        {
            step: '04',
            title: t('capabilityAssessment'),
            description: t('capabilityAssessmentDesc'),
            icon: 'Cog6ToothIcon',
        },
        {
            step: '05',
            title: t('performanceMonitoring'),
            description: t('performanceMonitoringDesc'),
            icon: 'ChartBarIcon',
        },
        {
            step: '06',
            title: t('periodicReverification'),
            description: t('periodicReverificationDesc'),
            icon: 'ArrowPathIcon',
        },
    ];

    return (
        <>
            <Header />
            <main className="min-h-screen bg-background">
                {/* Hero */}
                <section className="py-20 px-6 bg-gradient-to-b from-card to-background border-b border-border">
                    <div className="max-w-4xl mx-auto text-center">
                        <div className="inline-flex items-center space-x-2 px-4 py-2 bg-verified/10 rounded-full text-verified text-sm font-semibold mb-6">
                            <Icon name="ShieldCheckIcon" size={16} variant="solid" />
                            <span>{t('rigorousVerification')}</span>
                        </div>
                        <h1 className="text-5xl font-headline font-bold text-foreground mb-6">
                            {t('verificationProcessTitle')}
                        </h1>
                        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
                            {t('verificationProcessSubtitle')}
                        </p>
                    </div>
                </section>

                {/* Steps */}
                <section className="py-20 px-6">
                    <div className="max-w-4xl mx-auto space-y-12">
                        {steps.map((item, i) => (
                            <div key={i} className="flex gap-6 items-start">
                                <div className="flex-shrink-0">
                                    <div className="w-16 h-16 bg-primary text-primary-foreground rounded-lg flex items-center justify-center font-headline font-bold text-xl">
                                        {item.step}
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <h3 className="text-2xl font-headline font-bold text-foreground mb-3">{item.title}</h3>
                                    <p className="text-muted-foreground leading-relaxed mb-4">{item.description}</p>
                                    <div className="h-px bg-border"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Trust Badge */}
                <section className="py-20 px-6 bg-card">
                    <div className="max-w-4xl mx-auto text-center">
                        <Icon name="BadgeCheckIcon" size={64} variant="solid" className="text-verified mx-auto mb-6" />
                        <h2 className="text-3xl font-headline font-bold text-foreground mb-4">
                            {t('verifiedBadge')}
                        </h2>
                        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                            {t('verifiedBadgeDesc')}
                        </p>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
